import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, Typography, Tag, Button, Row, Col, Space, message } from 'antd';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { badgeActionStart, badgeActionError, getBadgeAction } from '../../core/data/redux/modules/badge/actions';
import { getBadgeById } from '../../services/adminServices/badge';

const { Title, Paragraph, Text } = Typography;

const BADGE_TYPES = [
  { value: 'POLL_COUNT_DRIVEN', label: 'Poll Count Driven' },
  { value: 'VOTE_RECEIVED_COUNT_DRIVEN', label: 'Vote Received Count Driven' },
  { value: 'VOTE_GIVEN_COUNT_DRIVEN', label: 'Vote Given Count Driven' },
  { value: 'POLL_STREAK_COUNT_DRIVEN', label: 'Poll Streak Count Driven' },
  { value: 'VOTE_STREAK_COUNT_DRIVEN', label: 'Vote Streak Count Driven' },
];

const formatBadgeType = (type: string) => {
  const badgeType = BADGE_TYPES.find(bt => bt.value === type);
  return badgeType ? badgeType.label : type;
};

const BadgeDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { badge, loading } = useSelector((state: any) => state.badge || { badge: null, loading: false });
  const [localBadge, setLocalBadge] = useState<any>(null);

  useEffect(() => {
    fetchBadge();
    // eslint-disable-next-line
  }, [id]);

  const fetchBadge = async () => {
    dispatch(badgeActionStart());
    try {
      const res = await getBadgeById(id!);
      if (res.error) throw new Error(res.message);
      dispatch(getBadgeAction(res.data));
      setLocalBadge(res.data);
    } catch (err: any) {
      dispatch(badgeActionError(err.message));
      message.error(err.message);
    }
  };

  if (loading || !localBadge) return <Card loading style={{ margin: 24 }} />;

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Badge Details</Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Title level={5}>Basic Information</Title>
              <Paragraph><Text strong>Name:</Text> {localBadge.name}</Paragraph>
              <Paragraph><Text strong>Type:</Text> {localBadge.type ? formatBadgeType(localBadge.type) : 'N/A'}</Paragraph>
              <Paragraph><Text strong>Status:</Text> <Tag color={localBadge.is_active ? 'green' : 'red'}>{localBadge.is_active ? 'Active' : 'Inactive'}</Tag></Paragraph>
            </Col>
          </Row>
          <Space style={{ marginTop: 32 }}>
            <Link to="/admin/badge/list-badges">
              <Button>Back to List</Button>
            </Link>
            {/* Optionally, add edit button/modal here */}
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default BadgeDetail; 